"use client"

import styled from "@emotion/styled"
import { Box } from "@mui/material"
import Image from "next/image"
import "swiper/css/effect-fade"
import { colors, mediaQueries, sizes } from "ui/theme/theme"
import SwiperMultiDevice from "../SwiperMultiDevice/SwiperMultiDevice"

const StyledImageContainer = styled(Box)`
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  height: 53px;
  background: ${colors.white};
  box-shadow: -4px 4px 26px 0px rgba(2, 1, 64, 0.12);

  ${mediaQueries.tablet} {
    width: 100%;
    height: 60px;
  }
`
const StyledSwiperOnMobile = styled(SwiperMultiDevice)`
  width: 100%;
  z-index: 10;

  ${mediaQueries.mobile} {
    margin: 0 20px;
    border-radius: ${sizes.baseDouble};
    background-color: ${colors.white};
    .swiper {
      width: 100%;
      padding: ${sizes.baseDouble} 0;
    }
    margin-top: -55px;
    margin-bottom: -33px;
  }
  ${mediaQueries.tablet} {
    margin-top: -87.5px;
    border-radius: ${sizes.baseDouble};
    background-color: ${colors.white};

    width: 1200px;
    max-width: 100%;
    .swiper {
      overflow: hidden;
      padding: ${sizes.baseDouble} 0;
      .swiper-slide {
        width: auto;
      }
    }
  }
  ${mediaQueries.desktopXl} {
    margin-top: -91.5px;
  }
`

interface ImageAndVideoBlockProps {
  data: any
  id?: string
}

const ImagesStrip = ({ data, id: pageId }: ImageAndVideoBlockProps) => {
  const { logos } = data

  return (
    <StyledSwiperOnMobile
      swiperProps={{
        spaceBetween: sizes.baseSingle,
        slidesPerView: 3,
        slidesPerGroup: 3,
        centeredSlides: false,
        watchOverflow: true,
        centerInsufficientSlides: true,
        initialSlide: 0,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
      }}
      desktopSwiperProps={{
        spaceBetween: sizes.baseTriple,
        slidesPerView: 7,
        // slidesPerGroup: 7,
        centeredSlides: false,
        navigation: false,
        watchOverflow: true,
        centerInsufficientSlides: true,
      }}
    >
      {logos?.mediaItems?.map((item: any, index: number) => {
        const { id, url, altText } = item
        // Set priority to true if id ends with -0 or -1
        const priority =
          typeof pageId === "string" &&
          (pageId.endsWith("-0") || pageId.endsWith("-1"))
        return (
          <StyledImageContainer key={id}>
            <Image
              key={`circle-image-card-list-item-${index}-${item?.title?.value}`}
              alt={altText || "logo"}
              src={url}
              fill
              priority={priority}
              style={{
                objectFit: "contain",
                objectPosition: "center",
              }}
            />
          </StyledImageContainer>
        )
      })}
    </StyledSwiperOnMobile>
  )
}

export default ImagesStrip
